import { render, staticRenderFns } from "./importDetail1.vue?vue&type=template&id=47d2a672&scoped=true&"
import script from "./importDetail1.vue?vue&type=script&lang=js&"
export * from "./importDetail1.vue?vue&type=script&lang=js&"
import style0 from "./importDetail1.vue?vue&type=style&index=0&id=47d2a672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2a672",
  null
  
)

export default component.exports